import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { Image, CloudinaryComponentProps, Transformation } from 'cloudinary-react';
import { Document, Page } from 'react-pdf';
import { Props as DocumentProps } from 'react-pdf/dist/Document';
import { Props as PageProps } from 'react-pdf/dist/Page';
import { getEnvironment } from '@minecraft.environment';

const environment = getEnvironment();
const cloudinaryDomain = environment.CLD_DOMAIN;

type sizeType = 'xsm' | 'sm' | 'md';

const thumbnailSizes: Record<sizeType, [number, number]> = {
  xsm: [40, 22],
  sm: [89, 50],
  md: [144, 81],
};

type CloudinaryDocumentPreviewProps = {
  guid?: string;
  fileKey?: string;
  cloudName?: string;
  isThumbnail?: boolean;
  thumbnailSizeType?: sizeType;
  index?: number | string;
  handleDocumentClick?: (index: number | string) => void;
  ['data-qa-id']?: string;
  documentProps?: DocumentProps;
  pageProps?: PageProps;
  className?: string;
} & CloudinaryComponentProps;

const DocumentWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: scroll;
`;

const CloudinaryDocumentPreview: FC<CloudinaryDocumentPreviewProps> = ({
  guid,
  fileKey,
  cloudName,
  isThumbnail = false,
  thumbnailSizeType = 'sm',
  index,
  handleDocumentClick,
  'data-qa-id': qaId,
  documentProps,
  pageProps,
  className,
  ...rest
}) => {
  const [numberOfPages, setNumberOfPages] = useState(0);
  const cloudinaryDocumentUrl = `https://${cloudinaryDomain}/${cloudName}/image/upload/${fileKey}`;
  const [wideDimension, narrowDimension] = thumbnailSizes[thumbnailSizeType];

  return (
    <div>
      {isThumbnail ? (
        <Image
          fetchFormat="auto"
          publicId="defaults/document-thumbnail_qmeb6q"
          cloudName={cloudName}
          data-qa-id={qaId}
          onClick={(): void => handleDocumentClick && handleDocumentClick(index)}
          {...rest}
          // DO NOT TOUCH, SHOULD NOT BE CHANGED
          secure
          secureDistribution={cloudinaryDomain}
        >
          <Transformation page={1} height={narrowDimension} width={wideDimension} crop="scale" />
        </Image>
      ) : (
        <DocumentWrapper className={className}>
          <Document
            data-qa-id={qaId}
            onItemClick={({ pageNumber }): void => handleDocumentClick && handleDocumentClick(pageNumber)}
            file={cloudinaryDocumentUrl}
            onLoadSuccess={({ numPages }): void => setNumberOfPages(numPages)}
            {...documentProps}
          >
            {Array.from(Array(numberOfPages), (el, idx) => (
              <Page key={`page_${idx + 1}`} pageNumber={idx + 1} {...pageProps} />
            ))}
          </Document>
        </DocumentWrapper>
      )}
    </div>
  );
};

export default CloudinaryDocumentPreview;
